module.exports = __webpack_public_path__ + "static/media/k3.d725638c.jfif";